import React from 'react'
import Button from '../../ui/Button/Button'
import './PriceButton.sass'

function PriceButton() {
  return (
    <div className="PriceButton">
      <Button
        theme="primary"
        title="Прайс"
        type="navhashlink"
        icon="table"
        iconWeight="solid"
        path="/price"
        size={40}
      />
    </div>
  )
}

export default PriceButton
